export default function loadTranslations(...names) {
    const projectName = 'frontend_resources';

    let translations = {};

    try {
        let rawTranslations = require(`../../translations/all.json`);
        Object.keys(rawTranslations).forEach((lang) => {
            if (!translations[lang]) {
                translations[lang] = {};
            }

            names.forEach(name => {
                if (rawTranslations[lang][projectName] && rawTranslations[lang][projectName][name]) {
                    Object.keys(rawTranslations[lang][projectName][name]).forEach(key => {
                        translations[lang][key] = rawTranslations[lang][projectName][name][key];
                    });
                }
            });
        });
    } catch (Error) {
        console.error(`Missing translations file: ${name}, add translations to Loco with the prefix: 'frontend_resources.${name}', and the tag 'frontend-resources'`);
    }

    let newData = {};

    for (let key in translations) {
        if (translations.hasOwnProperty(key)) {
            // Split the key at '-' and take the first part
            let newKey = key.split('-')[0];

            // Assign the value to the new key in the new object
            newData[newKey] = translations[key];
        }
    }

    return newData;
}
